(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[71510],{

/***/ 89041:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands",
      function () {
        return __webpack_require__(3171);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ SeveralBrandsHome; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/layouts/severalBrandsWrapper.tsx + 9 modules
var severalBrandsWrapper = __webpack_require__(73191);
// EXTERNAL MODULE: ./src/components/severalbrands/homePage/firstSection/textImageSharedComponent/index.tsx
var textImageSharedComponent = __webpack_require__(26784);
// EXTERNAL MODULE: ./src/components/severalbrands/homePage/firstSection/style.module.scss
var style_module = __webpack_require__(89182);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/firstSection/index.tsx



const simplifyingComplexDecisions = {
    img: "/severalbrands/assets/images/simplifyingComplexDecisions.webp",
    mainTitle: "High-Intent Lead Generation Company",
    secondTitle: "Pay for performance, not promises",
    paragraphs: [
        "We connect businesses with high-intent leads across legal, auto, B2B, B2C, and home services verticals. Our reach is nationwide, backed by local market expertise across every industry we serve.",
        "Pricing is performance-based and prepaid, so you pay for the leads you receive, not a flat retainer. And because we work across so many verticals, our team brings deep, industry-specific expertise to every partnership, not a one-size-fits-all approach to lead generation.", 
    ],
    mainH1Element: true
};
const deliveringOurPromises = {
    img: "/severalbrands/assets/images/deliveringOnOurPromises.webp",
    mainTitle: "Delivering on Our Promises",
    paragraphs: [
        "We generate real-time leads in-house through market research and performance marketing, not recycled data pulled from a third party. That means the prospects we send are current, relevant, and matched to what you're actually looking for.",
        "We built our process around consistent delivery, not a one-time sale. Pricing is performance-based and prepaid, and we work at the pace that makes sense for each partnership, checking in regularly to see how the leads we're sending are actually performing on your end.", 
    ],
    imgToLeft: true,
    showAnimation: true
};
function FirstSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (style_module_default()).bgStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `lg:py-28 py-16 3xl:py-16  ${(style_module_default())["hero-section"]}`,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(textImageSharedComponent/* default */.Z, {
                        info: simplifyingComplexDecisions
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "3xl:pt-5 3xl:pb-56 lg:pb-32 pb-32 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(textImageSharedComponent/* default */.Z, {
                        info: deliveringOurPromises
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components/severalbrands/homePage/thirdSection/style.module.scss
var thirdSection_style_module = __webpack_require__(7913);
var thirdSection_style_module_default = /*#__PURE__*/__webpack_require__.n(thirdSection_style_module);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs + 1 modules
var use_in_view = __webpack_require__(16893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/animation/hooks/use-animation.mjs + 1 modules
var use_animation = __webpack_require__(32233);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 111 modules
var motion = __webpack_require__(76265);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.tsx
var useWindowSize = __webpack_require__(91173);
;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/weAreGoodWithNumbers/sharedNumbersInfo.tsx




function SharedNumbersInfo({ info  }) {
    const windowSize = (0,useWindowSize/* default */.Z)();
    const { bgColor , description , icon , title , deferentStyle , animation , zIndex ,  } = info;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.li */.E.li, {
        className: `rounded-[20px] text-[#fff] 3xl:w-[375px] 3xl:h-[400px] lg:w-[225px] lg:h-[250px] 3xl:p-10 p-5 flex lg:flex-col   justify-between`,
        style: {
            backgroundColor: bgColor,
            zIndex: zIndex
        },
        variants: {
            show: windowSize.width < 1024 ? {
                y: [
                    30,
                    0
                ],
                opacity: [
                    0,
                    1
                ],
                transition: {
                    delay: animation?.delay,
                    duration: 1
                }
            } : {
                x: animation?.x,
                rotate: animation?.rotate,
                transition: {
                    delay: animation?.delay,
                    duration: 0.5
                }
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `   w-[73px] h-[68px] lg:w-[100px] lg:h-[100px] 3xl:w-[150px] 3xl:h-[150px]  ${deferentStyle ? "order-2" : "lg:order-1 order-2"} `,
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `${deferentStyle ? "order-1" : "lg:order-2 order-1"} `,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "font-bold 3xl:text-[4.5rem] 3xl:leading-[5.5rem] lg:text-[50px] text-4xl lg:leading-10",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-light 3xl:text-4xl lg:text-2xl text-xl",
                        children: description
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/weAreGoodWithNumbers/icons/clientsNumbersIcon.tsx


function ClientsNumbersIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 147 147",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "68.986",
                cy: "70.645",
                r: "18",
                fill: "#fff",
                transform: "rotate(-9.186 68.986 70.645)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                fillOpacity: "0.5",
                d: "M109.958 43.883a46.55 46.55 0 0110.231 34.133 46.549 46.549 0 01-16.901 31.371 46.546 46.546 0 01-34.133 10.231 46.567 46.567 0 01-31.37-16.901L73.87 73.3l36.087-29.417z"
            })
        ]
    });
}
/* harmony default export */ var clientsNumbersIcon = (ClientsNumbersIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/weAreGoodWithNumbers/icons/campaignsIcon.tsx


function CampaignsIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 105 107",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M81.779 72.356a35 35 0 11-52.803-45.954l26.401 22.977L81.78 72.356z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "22",
                cy: "85",
                r: "22",
                fill: "#fff",
                fillOpacity: "0.5"
            })
        ]
    });
}
/* harmony default export */ var campaignsIcon = (CampaignsIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/weAreGoodWithNumbers/icons/adSpendIcon.tsx


function AdSpendIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 118 84",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#fff",
                strokeWidth: "3",
                d: "M38.226 47.721l72.619-28.618a39.052 39.052 0 01-9.724 41.004 39.06 39.06 0 01-55.226-.956 39.055 39.055 0 01-7.669-11.43z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                fillOpacity: "0.5",
                d: "M15.808 48.172a24.829 24.829 0 0146.198-18.207l-23.099 9.103-23.099 9.104z"
            })
        ]
    });
}
/* harmony default export */ var adSpendIcon = (AdSpendIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/weAreGoodWithNumbers/index.tsx








function WeAreGoodWithNumbers() {
    const mainSectionDevRef = (0,react.useRef)(null);
    const windowSize = (0,useWindowSize/* default */.Z)();
    const list = [
        {
            title: "150+",
            description: "Clients",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(clientsNumbersIcon, {}),
            bgColor: "#8850C3",
            zIndex: 1,
            animation: {
                delay: 0.9,
                rotate: [
                    0,
                    windowSize.width < 2024 ? -10 : -5
                ],
                x: [
                    10000,
                    30
                ]
            }
        },
        {
            title: "2000+",
            description: "Campaigns",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(campaignsIcon, {}),
            bgColor: "#A872E2",
            deferentStyle: true,
            zIndex: 2,
            animation: {
                delay: 1.4,
                rotate: [
                    0
                ],
                x: [
                    10000,
                    0
                ]
            }
        },
        {
            title: "$100M+",
            description: "Ads",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(adSpendIcon, {}),
            bgColor: "#BD8CF2",
            zIndex: 3,
            animation: {
                delay: 1.9,
                rotate: [
                    0,
                    windowSize.width < 2024 ? 15 : 10
                ],
                x: [
                    10000,
                    -30
                ]
            }
        }, 
    ];
    const isInView = (0,use_in_view/* useInView */.Y)(mainSectionDevRef, {
        once: true
    });
    const firstEl = (0,use_animation/* useAnimation */._)();
    const secondEl = (0,use_animation/* useAnimation */._)();
    (0,react.useEffect)(()=>{
        if (isInView) {
            firstEl.start("visible").catch(()=>{});
            secondEl.start("show").catch(()=>{});
        }
    }, [
        isInView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.section */.E.section, {
        ref: mainSectionDevRef,
        className: `bg-[#B083E0]  rounded-[20px] lg:pr-20 lg:pl-12 px-6 3xl:py-24 lg:py-12 pt-16 pb-7 flex flex-col lg:flex-row lg:gap-16 gap-5`,
        style: {
            width: windowSize.width < 1024 ? "auto" : 0
        },
        variants: {
            visible: windowSize.width < 1024 ? {
                y: [
                    150,
                    0
                ],
                opacity: [
                    0,
                    1
                ]
            } : {
                width: "auto"
            }
        },
        transition: {
            duration: windowSize.width < 1024 ? 1.5 : 0.8,
            ease: "linear",
            type: "tween"
        },
        animate: firstEl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: " font-bold 3xl:text-[5.5rem] 3xl:leading-[6.5rem] 3xl:min-w-[530px] lg:text-6xl text-4xl lg:leading-[78px] leading-10 text-[#fff] lg:min-w-[360px] text-center lg:text-left ",
                children: "We're Good with Numbers"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.ul */.E.ul, {
                variants: {
                    show: {}
                },
                animate: secondEl,
                className: "flex flex-col lg:flex-row gap-3 lg:gap-0 ",
                children: list?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SharedNumbersInfo, {
                        info: el
                    }, index))
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/severalbrands/homePage/thirdSection/whatClientsSay/style.module.scss
var whatClientsSay_style_module = __webpack_require__(96051);
var whatClientsSay_style_module_default = /*#__PURE__*/__webpack_require__.n(whatClientsSay_style_module);
;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/whatClientsSay/icons/walkerIcon.tsx


function WalkerIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "30",
        height: "30",
        fill: "none",
        viewBox: "0 0 30 30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#2B2F34",
                d: "M29.96 15c0 8.284-6.707 15-14.98 15S0 23.284 0 15C0 6.716 6.707 0 14.98 0s14.98 6.716 14.98 15z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                fillRule: "evenodd",
                d: "M24.254 21.472h1.295L20.582 8.824h-1.347l-3.596 8.934-3.2-8.475h2.557L13.91 12.11l.289.8 1.298-3.628h1.22v-.462h-12.6v.462h1.408l4.45 12.188h.593l1.885-5.209-.284-.786-.97 2.754L7.86 9.284h2.41l4.448 12.188h.704l1.524-3.928h5.411l-.399-1.027h-4.642l2.537-6.488 4.4 11.443z",
                clipRule: "evenodd"
            })
        ]
    });
}
/* harmony default export */ var walkerIcon = (WalkerIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/whatClientsSay/icons/shelikofIcon.tsx


function ShelikofIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "76",
        height: "30",
        fill: "none",
        viewBox: "0 0 76 30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                fill: "#000",
                clipPath: "url(#clip0_1_28682)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M9.548 16.686h2.393c.026.031.042.043.048.058.01.015.016.038.012.053A54146.08 54146.08 0 018.744 29.87H6.948c.287-1.158.563-2.305.854-3.448.29-1.136.581-2.274.897-3.403.321-1.14.673-2.27.953-3.426-.783 1.386-1.442 2.826-2.141 4.247-.706 1.435-1.394 2.877-2.102 4.338H4.147c-.056-1.452.098-2.876.08-4.305-.02-1.428-.004-2.856-.049-4.291-.672 3.463-1.578 6.867-2.448 10.297-.132.007-.24.016-.348.016H.102c-.06-.042-.08-.051-.089-.067a.078.078 0 01-.009-.05c.012-.091.014-.184.036-.273 1.075-4.26 2.153-8.521 3.235-12.804h2.433c.02.102.058.203.058.305 0 1.639.015 3.276-.014 4.914-.013.769-.116 1.537-.167 2.306-.018.252-.002.507.025.766 1.102-2.868 2.655-5.517 3.942-8.302l-.004-.003zM63.605 29.892h-1.22c-.109 0-.218-.014-.376-.023-.365-2.781-.728-5.556-1.09-8.333h-.05c-.305 1.384-.594 2.773-.92 4.152-.324 1.391-.682 2.773-1.032 4.18h-1.756l3.316-13.175h1.532c.04.157.102.328.125.503.164 1.384.313 2.77.48 4.154.156 1.287.326 2.573.521 3.867.225-.538.23-1.125.359-1.683.133-.572.236-1.15.37-1.721.13-.571.282-1.138.427-1.707l.434-1.706.436-1.703h1.768l-3.322 13.195h-.002zM18.757.106h1.567c.107 0 .213.016.39.03-.457 1.826-.907 3.615-1.354 5.403.35.12 1.634.146 2.386.048.459-1.809.92-3.634 1.383-5.463h1.923c0 .39-2.954 12.29-3.281 13.205h-1.966c.512-2.04 1.01-4.035 1.518-6.063h-2.397c-.505 2-1.01 4.002-1.525 6.032h-1.919c.007-.454 2.77-11.597 3.27-13.192h.005zM23.278 16.706c.857 0 1.65-.002 2.442 0 .22 0 .443.034.663.038.434.009.837.135 1.229.303.784.34 1.126.988 1.173 1.787.025.434-.024.884-.109 1.311-.196.973-.478 1.92-1.013 2.777-.43.69-.975 1.243-1.716 1.597-.047.022-.085.069-.165.133.274 1.71.552 3.44.837 5.206h-2.117l-.594-4.907h-.701l-1.242 4.91H19.97l3.31-13.155h-.002zm.3 6.748c1.365.17 2.11-.396 2.48-1.349.348-.894.606-1.816.701-2.761.063-.611-.146-.924-.583-1.07-.398-.133-.81-.215-1.257-.137-.448 1.774-.889 3.53-1.34 5.32v-.003zM52.377 10.898c-.04-.782.171-1.528.352-2.275.351-1.461.725-2.916 1.102-4.371.28-1.074.683-2.093 1.429-2.948A3.518 3.518 0 0157.595.07c.41-.05.803-.031 1.209.006 1.222.115 1.654.893 1.798 1.708.143.797.018 1.574-.169 2.34a271.405 271.405 0 01-1.4 5.486c-.238.894-.63 1.723-1.256 2.43-1.062 1.195-2.382 1.66-3.935 1.266-.89-.226-1.347-.809-1.463-1.798-.024-.2-.004-.406-.004-.607l.002-.002zm6.266-8.25l-.024-.004c0-.09.004-.184 0-.274-.023-.51-.236-.742-.74-.78-.578-.044-1.008.221-1.27.709a5 5 0 00-.452 1.116 504.674 504.674 0 00-1.65 6.493c-.091.37-.129.76-.136 1.142-.01.572.334.877.915.842.474-.029.857-.25 1.082-.664.183-.337.35-.694.448-1.061A579.326 579.326 0 0058.46 3.73c.089-.354.124-.72.184-1.08l-.002-.002zM46.743.137h1.983c-.436 1.905-.96 3.75-1.293 5.65.247-.377.496-.751.741-1.128.915-1.404 1.837-2.803 2.738-4.216.16-.25.33-.357.626-.343.492.02.986.006 1.56.006-.142.235-.231.39-.331.54-1.171 1.766-2.336 3.533-3.522 5.289-.194.286-.236.56-.185.879.22 1.395.434 2.79.652 4.183.092.58.194 1.156.285 1.736.027.178.034.36.051.57h-2.105c-.283-2.045-.566-4.088-.846-6.126-.054 0-.074-.004-.09 0a.066.066 0 00-.035.038l-1.55 6.09H43.43L46.743.139V.137zM35.586 29.865h-2.084c-.323-2.024-.565-4.084-.915-6.141-.345 1.003-.576 2.026-.832 3.043-.26 1.027-.523 2.055-.788 3.1H29.03c.009-.126 0-.248.029-.36 1.03-4.107 2.063-8.212 3.096-12.318.04-.157.098-.31.156-.492h1.92c-.014.129-.01.25-.039.366-.416 1.652-.837 3.304-1.253 4.958-.025.1-.018.208-.033.445.574-.879 1.072-1.645 1.573-2.414.655-1.003 1.32-1.997 1.953-3.014.182-.292.39-.394.719-.378.46.022.921.006 1.473.006-.107.195-.171.332-.256.459-1.17 1.765-2.337 3.532-3.524 5.286-.233.345-.289.669-.213 1.08.196 1.064.338 2.137.505 3.205.136.87.278 1.738.412 2.606.027.175.027.357.04.56l-.002.003zM72.928 29.872h-1.282c.026-.39.053-.764.082-1.176-.38.316-.701.615-1.057.87-.55.392-1.162.512-1.841.39-.828-.15-1.403-.828-1.565-1.654-.17-.857-.034-1.69.162-2.507.443-1.836.922-3.66 1.41-5.486.253-.952.692-1.822 1.377-2.546a3.557 3.557 0 012.389-1.14c.445-.036.88-.047 1.32.021.91.142 1.429.733 1.48 1.641.054.957-.298 1.794-.703 2.631h-1.512c.098-.438.2-.844.274-1.256.065-.363.076-.73-.071-1.085-.091-.219-.24-.36-.485-.4-.537-.089-.982.05-1.32.491-.334.434-.501.941-.633 1.457a1064.58 1064.58 0 00-1.636 6.507c-.053.212-.075.434-.109.65-.064.401-.031.782.33 1.041.327.233.877.189 1.253-.084.42-.303.692-.733.852-1.2.256-.744.437-1.512.644-2.272.017-.064-.005-.137-.01-.241-.289-.014-.56-.025-.867-.038-.043-.445.169-.82.24-1.21.419-.097 1.981-.121 2.947-.041l-1.671 6.646.002-.01zM16.508 16.69h2.204c.027.054.058.087.056.118-.05.733-.1 1.464-.152 2.197-.006.09-.024.182-.029.275-.049.936-.086 1.873-.146 2.808-.092 1.392-.203 2.783-.294 4.174-.058.899-.094 1.798-.145 2.697-.018.293-.051.583-.08.904h-1.98c.037-.762.17-1.513.188-2.294H13.7c-.39.708-.61 1.525-.977 2.296h-1.997c1.94-4.416 3.854-8.78 5.784-13.174h-.003zm-.204 9.308c.238-2.212.47-4.376.7-6.54l-.106-.023-2.605 6.563h2.011zM7.996 9.153H9.53c-.092.44-.2.848-.25 1.26-.03.265-.013.551.047.812.111.474.45.691.942.67.788-.036 1.326-.55 1.416-1.358.057-.54.002-1.068-.256-1.555-.397-.748-.804-1.488-1.203-2.234-.215-.406-.45-.806-.627-1.227-.86-2.042.151-4.44 2.092-5.207.88-.347 1.792-.42 2.712-.146.821.246 1.235.82 1.282 1.661.051.921-.314 1.716-.695 2.527h-1.502c.089-.454.176-.881.251-1.311.025-.144.042-.292.031-.438-.07-.946-.823-1.327-1.651-.84-.595.348-.946 1.138-.708 1.812.213.602.527 1.169.817 1.742.445.886.941 1.75 1.353 2.651.786 1.719.076 3.601-1.026 4.52-.659.55-1.422.85-2.268.932a4.6 4.6 0 01-1.545-.088c-.802-.2-1.41-.76-1.414-1.725-.004-.895.292-1.683.668-2.458zM28.193.137h4.98l-.383 1.555h-3.05a90.779 90.779 0 00-.982 3.935h2.373c-.136.552-.256 1.043-.383 1.55-.402.129-.81.045-1.21.06-.386.016-.773.002-1.198.002a179.726 179.726 0 00-1.135 4.533h3.043a443.1 443.1 0 00-.379 1.535h-5.004c.062-.649 3.137-12.804 3.33-13.172l-.002.002zM43.448 23.804h-2.384c-.378 1.492-.755 2.98-1.144 4.524h3c-.013.567-.213 1.034-.331 1.537h-4.935c-.03-.02-.05-.029-.058-.042a.08.08 0 01-.009-.051c.011-.09.013-.184.036-.272l3.232-12.805h5.053l-.379 1.54c-.51.066-1.026.024-1.538.03-.496.007-.995 0-1.536 0l-.988 3.909H43.8c-.025.589-.214 1.076-.352 1.625v.005zM64.228.133h5.058l-.392 1.594h-3.043c-.374 1.282-.661 2.562-1 3.896.798.008 1.563.02 2.392.028-.145.56-.277 1.061-.412 1.59h-2.389l-1.531 6.062h-1.995C62.02 8.916 63.118 4.555 64.228.135V.133zM49.047 18.272h-2.13c.133-.54.25-1.027.367-1.495.035-.03.046-.044.062-.053.016-.011.031-.024.047-.026.073-.012.145-.027.218-.027 1.943 0 3.889 0 5.832.006.034 0 .065.03.123.056-.12.487-.243.979-.377 1.515-.703.062-1.402 0-2.143.04l-2.919 11.577h-1.994l2.916-11.593h-.002zM31.893 13.3C33 8.896 34.1 4.53 35.207.128 35.848.084 36.47.12 37.153.104c-.027.206-.034.363-.072.514l-2.666 10.61c-.04.157-.06.316-.103.533h2.705a571.84 571.84 0 00-.374 1.54H31.89h.003zM54.164 29.863h-1.996c1.11-4.412 2.212-8.787 3.316-13.168h1.997l-3.314 13.168h-.003zM41.783.106h1.454c.145 0 .287.016.43.025 0 .396-1.886 8.043-3.248 13.192-.621.013-1.26.008-1.897 0-.005-.488 2.625-11.128 3.261-13.219v.002z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_28682",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H75.405V30H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var shelikofIcon = (ShelikofIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/whatClientsSay/icons/staxIcon.tsx


function StaxIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "85",
        height: "30",
        fill: "none",
        viewBox: "0 0 85 30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_28701)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#B93BE4",
                        d: "M74.01 3.535v.88l2.464 1.233L74.01 6.88v.88l4.24-2.112-4.24-2.113zm0 5.106v.88l5.134-2.553 5.135 2.553v-.88l-5.135-2.553-5.134 2.553zm5.134-6.088L74.01 0v.88l5.134 2.553L84.28.88V0l-5.135 2.553zM84.28 6v-.88l-2.465-1.232 2.465-1.233v-.88l-4.24 2.113L84.28 6zm-10.27-3.345L84.265 7.76v-.88L74.01 1.775v.88z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#1D1D1B",
                        d: "M26.626 19.98v-4.474h5.985V9.521h-5.985V3.535H20.64v16.43c0 5.517 4.503 10.02 10.034 10.02h1.95v-5.97h-1.95a4.035 4.035 0 01-4.05-4.035zM7.584 17.648l3.022 5.501a.578.578 0 01-.513.866H0V30h11.78c4.18 0 6.836-4.474 4.826-8.127l-3.022-5.501a.578.578 0 01.514-.866h5.237v-5.97h-6.91c-4.195 0-6.85 4.46-4.84 8.112zm65.003-2.142h1.437V9.521h-1.276a11.473 11.473 0 00-8.978 4.327 11.45 11.45 0 00-8.978-4.327h-1.276v5.985h1.438c2.626 0 4.826 1.82 5.427 4.254-.601 2.435-2.801 4.255-5.428 4.255h-1.437V19.57c0-5.751-4.68-10.43-10.445-10.43-5.765 0-10.445 4.679-10.445 10.43C32.626 25.32 37.32 30 43.07 30h3.154v-5.985H43.07a4.455 4.455 0 01-4.46-4.445 4.455 4.455 0 014.46-4.445 4.455 4.455 0 014.46 4.445V30h7.261c3.536 0 6.836-1.628 8.978-4.328A11.45 11.45 0 0072.748 30h1.276v-5.985h-1.437c-2.626 0-4.827-1.82-5.428-4.255a5.56 5.56 0 015.428-4.254z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_28701",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H84.279V30H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var staxIcon = (StaxIcon);

// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./src/components/severalbrands/homePage/thirdSection/sharedSlider/style.module.scss
var sharedSlider_style_module = __webpack_require__(55727);
var sharedSlider_style_module_default = /*#__PURE__*/__webpack_require__.n(sharedSlider_style_module);
;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/icons/rightArrowIcon.tsx


function RightArrowIcon({ fill  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 9 14",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: fill,
            fillRule: "evenodd",
            d: "M.408.41a1.4 1.4 0 000 1.98L5.018 7l-4.61 4.61a1.4 1.4 0 101.98 1.98l5.6-5.6a1.4 1.4 0 000-1.98l-5.6-5.6a1.4 1.4 0 00-1.98 0z",
            clipRule: "evenodd"
        })
    });
}
/* harmony default export */ var rightArrowIcon = (RightArrowIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/icons/leftArrowIcon.tsx


function LeftArrowIcon({ fill  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 9 14",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: fill,
            fillRule: "evenodd",
            d: "M7.99.41a1.4 1.4 0 010 1.98L3.38 7l4.61 4.61a1.4 1.4 0 11-1.98 1.98l-5.6-5.6a1.4 1.4 0 010-1.98l5.6-5.6a1.4 1.4 0 011.98 0z",
            clipRule: "evenodd"
        })
    });
}
/* harmony default export */ var leftArrowIcon = (LeftArrowIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/whatClientsSay/icons/quotationIcon.tsx


function QuotationIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 37 25",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#B083E0",
            d: "M0 16.308C0 13.212 1.368 9.72 4.104 5.832 6.84 1.944 8.892 0 10.26 0c1.296 0 1.944.432 1.944 1.296 0 .36-.324 1.584-.972 3.672-.576 2.016-.864 3.492-.864 4.428 0 .936.252 1.548.756 1.836 2.304 1.584 3.456 3.924 3.456 7.02 0 1.872-.72 3.384-2.16 4.536-1.368 1.152-3.168 1.728-5.4 1.728-4.68 0-7.02-2.736-7.02-8.208zm21.6 0c0-3.096 1.368-6.588 4.104-10.476C28.44 1.944 30.492 0 31.86 0c1.296 0 1.944.432 1.944 1.296 0 .36-.324 1.584-.972 3.672-.576 2.016-.864 3.492-.864 4.428 0 .936.252 1.548.756 1.836 2.304 1.584 3.456 3.924 3.456 7.02 0 1.872-.72 3.384-2.16 4.536-1.368 1.152-3.168 1.728-5.4 1.728-4.68 0-7.02-2.736-7.02-8.208z"
        })
    });
}
/* harmony default export */ var quotationIcon = (QuotationIcon);

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/sharedSlider/index.tsx











function ShareSlider({ list , deferentStyle , perPage  }) {
    const leftArrowAnimation = {
        scale: [
            1,
            1.5,
            1
        ],
        transition: {
            duration: 0.8,
            repeat: Infinity,
            delay: 0.3
        }
    };
    const rightArrowAnimation = {
        scale: [
            1,
            1.5,
            1
        ],
        transition: {
            duration: 0.8,
            repeat: Infinity,
            delay: 0.3
        }
    };
    const sliderRef = (0,react.useRef)(null);
    const next = ()=>{
        sliderRef.current?.slickNext();
    };
    const previous = ()=>{
        sliderRef.current?.slickPrev();
    };
    const settings = deferentStyle ? {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: perPage,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    dots: true,
                    dotsClass: `slick-dots ${(sharedSlider_style_module_default()).dotsStyle} `
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    dotsClass: `slick-dots ${(sharedSlider_style_module_default()).dotsStyle} `
                }
            }, 
        ]
    } : {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: perPage,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    dots: true,
                    dotsClass: `slick-dots ${(sharedSlider_style_module_default()).dotsStyle} `
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.span */.E.span, {
                className: ` cursor-pointer p-2 z-1000 hidden sm:block relative  w-[29px] h-[34px] 3xl:w-[39px] 3xl:h-[44px] `,
                onClick: previous,
                whileHover: leftArrowAnimation,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(leftArrowIcon, {
                    fill: "#2B2F34"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: ` ${deferentStyle ? "3xl:max-w-[1080px] max-w-[770px]" : "3xl:max-w-[700px] max-w-[580px]"} `,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                    ref: sliderRef,
                    ...settings,
                    children: list.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (sharedSlider_style_module_default()).slide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: deferentStyle ? (sharedSlider_style_module_default()).sliderMainContainerDeferentStyle : (sharedSlider_style_module_default()).sliderMainContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: `${deferentStyle ? "h-[30px] lg:h-[40px] 3xl:h-[50px] 3xl:w-[279px] w-[200px] lg:w-[239px]    relative flex justify-center items-center mx-auto" : "block relative w-[37px] h-[25px] 3xl:w-[42px] 3xl:h-[30px] "}`,
                                                children: deferentStyle ? el.mainLogo : /*#__PURE__*/ (0,jsx_runtime.jsx)(quotationIcon, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: `3xl:text-xl font-light 3xl:leading-8 ${deferentStyle ? "mt-6 text-center " : "mt-3"} `,
                                                children: el.description
                                            })
                                        ]
                                    }),
                                    !deferentStyle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center gap-3 mt-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: el.iconName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "3xl:text-base text-[11px] text-[#474747]",
                                                        children: el.name
                                                    }),
                                                    el.url && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "3xl:text-base text-[11px] text-[#474747] underline",
                                                        children: el.url
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, index))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.span */.E.span, {
                whileHover: rightArrowAnimation,
                onClick: next,
                className: ` cursor-pointer p-2 z-1000 hidden sm:block relative  w-[29px] h-[34px] 3xl:w-[39px] 3xl:h-[44px] `,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(rightArrowIcon, {
                    fill: "#2B2F34"
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/whatClientsSay/index.tsx









const list = [
    {
        description: "Several Brands have consistently supplied high-quality leads and excellent customer service. The team has been very receptive and prompt in responding to any worries we have had. We look forward to continuing to scale our campaigns with them.",
        iconName: /*#__PURE__*/ (0,jsx_runtime.jsx)(walkerIcon, {}),
        name: "Blake Holiday, Sr. Affiliate Manager, Walker Advertising."
    },
    {
        description: "I've had the pleasure of working with Several Brands for years. Their team is comprised of skilled professionals who are passionate and experienced in what they do. I'd recommend Several Brands to anyone looking for high-quality leads and a solid partner.",
        iconName: /*#__PURE__*/ (0,jsx_runtime.jsx)(shelikofIcon, {}),
        name: "Noah Fields, Co-Founder, Shelikof Marketing."
    },
    {
        description: "Working with the Several Brands team has been nothing short of exceptional. Since the beginning of our partnership, it's been clear that our team's success was their top priority, and they have been willing to experiment with new ideas and strategies in an effort to help grow our partnership into one that's profitable for both sides. We are so grateful for their transparency.",
        iconName: /*#__PURE__*/ (0,jsx_runtime.jsx)(staxIcon, {}),
        name: "Kyle Maley, Affiliate Marketing Manager, Stax."
    }, 
];
function WhatClientsSay() {
    const windowSize = (0,useWindowSize/* default */.Z)();
    const mainSectionDevRef = (0,react.useRef)(null);
    const isInView = (0,use_in_view/* useInView */.Y)(mainSectionDevRef, {
        once: true
    });
    const firstEl = (0,use_animation/* useAnimation */._)();
    const secondEl = (0,use_animation/* useAnimation */._)();
    (0,react.useEffect)(()=>{
        if (isInView) {
            firstEl.start("visible").catch(()=>{});
            secondEl.start("visible").catch(()=>{});
        }
    }, [
        isInView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.section */.E.section, {
        id: "testimonials-1",
        ref: mainSectionDevRef,
        className: (whatClientsSay_style_module_default()).bgStyle,
        variants: {
            visible: windowSize.width < 1024 ? {
                y: [
                    150,
                    0
                ],
                opacity: [
                    0,
                    1
                ]
            } : {
                x: [
                    -1000,
                    0
                ]
            }
        },
        transition: {
            duration: 1.5
        },
        animate: firstEl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "3xl:max-w-[700px] lg:max-w-[450px] px-4 lg:px-0 z-10 lg:mt-10 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold 3xl:text-7xl lg:text-5xl text-3xl lg:leading-[54px] leading-9 ",
                        children: "What Clients Say"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[#351C4F] 3xl:mt-5 mt-3 3xl:text-2xl 3xl:leading-10 text-lg leading-8 font-light",
                        children: "At SeveralBrands, we help businesses expand reach, engage target audiences, and convert leads into customers. Here's what our clients have to say."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                variants: {
                    visible: windowSize.width < 1024 ? {} : {
                        x: [
                            2000,
                            0
                        ],
                        transition: {
                            duration: 1.5
                        }
                    }
                },
                animate: secondEl,
                className: "sm:flex z-10 items-center justify-center ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareSlider, {
                    deferentStyle: false,
                    list: list,
                    perPage: 1
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/whyOutsource/icons/hubSpotIcon.tsx


function HubSpotIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 137 40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_547)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#33475B",
                        d: "M14.813 6.418v10.936H4.766V6.418H0v26.105h4.768V21.942h10.044v10.58h4.769V6.419h-4.768zM34.84 24.085a3.945 3.945 0 01-7.89 0V12.903h-4.523v11.182a8.459 8.459 0 1016.92 0V12.903H34.84v11.182zm33.511-10.03c0-2.293 1.516-3.019 3.177-3.019 1.34 0 3.107 1.02 4.265 2.255l2.96-3.491c-1.478-2-4.477-3.382-6.932-3.382-4.907 0-8.456 2.874-8.456 7.637 0 8.84 10.803 6.034 10.803 10.981 0 1.525-1.481 2.872-3.177 2.872-2.675 0-3.542-1.307-4.77-2.69l-3.288 3.418c2.103 2.58 4.697 3.892 7.803 3.892 4.662 0 8.411-2.909 8.411-7.456 0-9.811-10.803-6.762-10.803-11.017m66.838 14.297c-2.672 0-3.432-1.156-3.432-2.926v-7.839h4.155v-3.972h-4.155v-5.24l-4.586 2.059V26.4c0 4.084 2.818 6.142 6.681 6.142a9.428 9.428 0 001.809-.145l1.119-4.118c-.504.035-1.084.07-1.591.07M52.057 13.032c-2.24 0-3.804.65-5.316 2.133V6.574h-4.53v15.927c0 5.96 4.31 10.046 9.154 10.046 5.373 0 10.1-4.157 10.1-9.755 0-5.528-4.35-9.755-9.408-9.755m-.029 14.951a5.14 5.14 0 110-10.28 5.14 5.14 0 010 10.28zm49.216-5.433c0-5.608-4.716-9.755-10.1-9.755-4.842 0-9.153 4.084-9.153 10.046v15.936h4.529v-8.604c1.51 1.48 3.076 2.133 5.314 2.133 5.058 0 9.41-4.227 9.41-9.756zm-4.29-.057a5.14 5.14 0 11-10.28 0 5.14 5.14 0 0110.28 0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FF7A59",
                        d: "M115.88 12.581v-4.55a3.502 3.502 0 002.021-3.16v-.104a3.505 3.505 0 00-3.505-3.504h-.104a3.507 3.507 0 00-3.505 3.504v.105a3.51 3.51 0 002.021 3.158v4.551a9.92 9.92 0 00-4.719 2.078L95.608 4.937c.089-.32.135-.651.14-.983a3.948 3.948 0 10-3.953 3.94 3.906 3.906 0 001.944-.528l12.291 9.564a9.957 9.957 0 00.152 11.213l-3.738 3.739a3.21 3.21 0 00-.934-.152 3.244 3.244 0 00-2.29 5.535 3.242 3.242 0 005.535-2.29 3.221 3.221 0 00-.152-.934l3.698-3.7a9.972 9.972 0 107.579-17.76zm-1.533 14.968a5.12 5.12 0 01-4.854-3.124 5.116 5.116 0 014.854-7.104 5.117 5.117 0 01.005 10.225"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_547",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H136.774V40H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var hubSpotIcon = (HubSpotIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/whyOutsource/icons/revenueHeroIcon.tsx


const RevenueHeroIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "221",
        height: "40",
        fill: "none",
        viewBox: "0 0 221 40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2937_4589)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M41.095 1.053h-24a4.36 4.36 0 0 0-3.04 1.232c-.397.388-.712.849-.927 1.357a4.1 4.1 0 0 0-.327 1.602v15.238l3.717-2.814V5.244a.58.58 0 0 1 .173-.397.6.6 0 0 1 .41-.163h24a.6.6 0 0 1 .42.171c.112.11.175.258.175.413V26.04a.57.57 0 0 1-.238.455l-11.997 8.757a.6.6 0 0 1-.35.117.56.56 0 0 1-.346-.117l-12.003-8.757a.53.53 0 0 1-.166-.199.6.6 0 0 1-.066-.256v-3.392l-3.73 2.808v.554a4.06 4.06 0 0 0 .459 1.88c.3.582.734 1.088 1.267 1.477l11.997 8.757a4.4 4.4 0 0 0 2.578.829c.928 0 1.83-.29 2.579-.829l11.997-8.757c.533-.39.966-.895 1.267-1.477a4.07 4.07 0 0 0 .457-1.88V5.244c0-.55-.11-1.096-.327-1.604a4.2 4.2 0 0 0-.933-1.355 4.36 4.36 0 0 0-3.046-1.232"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint0_linear_2937_4589)",
                        d: "m5.706 30.843 7.096-5.389V20.48L3.16 27.779z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint1_linear_2937_4589)",
                        d: "m47.546 4.385 1.957 2.638-4.104 2.92-3.718 2.813-4.562 3.445-4.306 3.263-2.135 1.612-2.284-1.635-7.316-5.254-4.562 3.444v4.957l4.306-3.27.256.187 4.33 3.135 4.96 3.596 2.445-1.833 4.306-3.234 4.562-3.421 3.718-2.785 6.543-5.038 2.444 2.516.976-8.091z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M16.512 17.664v4.957l-3.711 2.831v-4.968zM32.814 9.095v6.66h-7.406V2.913h-4.33v11.29l9.6 6.878 2.135-1.634v14.717l4.307-2.434V9.095zm-11.736 17.17h4.33v-3.568l-4.33-3.14zM65.552 20.004a.81.81 0 0 1 .758.45l2.234 4.35a.75.75 0 0 0 .713.458h3.09a.34.34 0 0 0 .205-.09.2.2 0 0 0 .06-.158.3.3 0 0 0-.045-.15l-2.757-4.95a.45.45 0 0 1-.06-.36.49.49 0 0 1 .264-.39 4.26 4.26 0 0 0 1.695-1.617 4.2 4.2 0 0 0 .578-2.26c0-4.145-3.727-4.761-5.947-4.761h-4.643a1.68 1.68 0 0 0-1.217.476 1.65 1.65 0 0 0-.495 1.199v12.73a.41.41 0 0 0 .356.33h3.03a.35.35 0 0 0 .265-.097.26.26 0 0 0 .098-.233V21.35a1.1 1.1 0 0 0-.272-.669.93.93 0 0 0-.758-.3v-.376zm-3.03-6.376v-.376h3.788c.55-.02 1.088.16 1.515.503a1.97 1.97 0 0 1 .583 1.503c0 1.209-.757 1.922-2.113 1.922h-1.91a.76.76 0 0 1-.605-.263.75.75 0 0 1-.243-.57v-1.758a1 1 0 0 0-.31-.685 1 1 0 0 0-.705-.276M85.7 13.385a.39.39 0 0 0 .371-.205q.027-.064.018-.133v-2.144a.33.33 0 0 0-.1-.279.35.35 0 0 0-.29-.096H76.49a1.8 1.8 0 0 0-.68.122 1.8 1.8 0 0 0-.577.367 1.7 1.7 0 0 0-.383.553 1.6 1.6 0 0 0-.131.652V24.91c.014.09.059.173.126.236a.44.44 0 0 0 .248.117h10.81a.4.4 0 0 0 .288-.098.28.28 0 0 0 .101-.255v-2.122c0-.27-.117-.382-.39-.382h-6.587a.9.9 0 0 1-.623-.251.83.83 0 0 1-.25-.604v-1.02a1 1 0 0 0-.328-.672 1.07 1.07 0 0 0-.718-.273v-.374h6.836a.39.39 0 0 0 .28-.105.36.36 0 0 0 .11-.27v-1.98a.32.32 0 0 0-.1-.278.36.36 0 0 0-.29-.097h-4.917a.9.9 0 0 1-.626-.254.84.84 0 0 1-.248-.608v-.907c0-.13-.029-.26-.082-.38a1 1 0 0 0-.228-.32 1.04 1.04 0 0 0-.735-.283v-.374zM100.759 10.526h-2.833a.75.75 0 0 0-.404.105.6.6 0 0 0-.216.33l-2.99 9.638h-.128a.27.27 0 0 1-.291-.24l-2.826-9.405a.8.8 0 0 0-.217-.308.63.63 0 0 0-.404-.12h-2.81a.33.33 0 0 0-.233.09.25.25 0 0 0-.06.158v.15l4.344 13.833a.675.675 0 0 0 .748.495H95.9c.185.03.374-.01.531-.112a.9.9 0 0 0 .224-.36l4.374-13.901v-.098a.25.25 0 0 0-.075-.172.33.33 0 0 0-.195-.083M114.189 13.385a.33.33 0 0 0 .263-.098.27.27 0 0 0 .093-.24v-2.144a.35.35 0 0 0-.091-.279.32.32 0 0 0-.265-.096h-8.393a1.5 1.5 0 0 0-.619.123 1.6 1.6 0 0 0-.525.366c-.15.158-.268.346-.348.553s-.119.429-.116.652V24.91c.011.09.05.172.111.236a.38.38 0 0 0 .223.116h9.832a.34.34 0 0 0 .339-.212q.024-.069.016-.14v-2.122c0-.27-.107-.382-.355-.382h-6.004a.8.8 0 0 1-.309-.066.8.8 0 0 1-.432-.463.9.9 0 0 1-.057-.326v-1.02a1.03 1.03 0 0 0-.298-.672.93.93 0 0 0-.654-.273v-.375h6.231a.32.32 0 0 0 .259-.102.3.3 0 0 0 .075-.125.4.4 0 0 0 .021-.147v-1.98a.35.35 0 0 0-.091-.278.309.309 0 0 0-.264-.096h-4.481a.76.76 0 0 1-.572-.255.86.86 0 0 1-.226-.608v-.907a1 1 0 0 0-.282-.7.902.902 0 0 0-.67-.282v-.376zM129.106 10.53h-1.3a1.5 1.5 0 0 0-.616.12 1.6 1.6 0 0 0-.524.365 1.7 1.7 0 0 0-.349.553c-.08.208-.122.43-.121.656l-.203 6.994-.31-.667-.12-.195-.224-.382-.401-.66a30 30 0 0 1-.632-1.064l-.239-.39c-.197-.315-.43-.705-.703-1.147l-1.483-2.482-.703-1.117a1.1 1.1 0 0 0-.426-.45 1 1 0 0 0-.586-.135h-.703c-.422 0-.827.178-1.126.496a1.76 1.76 0 0 0-.47 1.199v12.685c.013.088.052.17.111.234a.4.4 0 0 0 .22.118h2.65a.334.334 0 0 0 .247-.097.4.4 0 0 0 .079-.116.4.4 0 0 0 .031-.14l.226-8.006.309.66s.042.075.231.367l.507.825.653 1.064c.176.315.415.697.703 1.155l.239.39a656 656 0 0 1 2.193 3.576.6.6 0 0 0 .231.245.56.56 0 0 0 .318.077h2.291a.34.34 0 0 0 .246-.112.45.45 0 0 0 .091-.263V10.882a.46.46 0 0 0-.105-.293.3.3 0 0 0-.232-.06M145.884 10.53h-1.621a1.71 1.71 0 0 0-1.493.917 1.46 1.46 0 0 0-.179.739v7.387c0 1.862-.882 2.815-2.622 2.815s-2.629-.975-2.629-2.815v-8.695a.32.32 0 0 0-.228-.332.34.34 0 0 0-.144-.015h-1.621a2 2 0 0 0-.575.096 1.7 1.7 0 0 0-.531.325 1.4 1.4 0 0 0-.409.517 1.46 1.46 0 0 0-.179.739v7.388c0 3.65 2.239 5.666 6.339 5.666 4.099 0 6.287-2.017 6.287-5.666v-8.718a.327.327 0 0 0-.245-.34.34.34 0 0 0-.15-.007M159.463 13.385a.34.34 0 0 0 .264-.098.26.26 0 0 0 .075-.107.26.26 0 0 0 .017-.133v-2.144a.4.4 0 0 0-.014-.15.331.331 0 0 0-.199-.208.3.3 0 0 0-.143-.017h-8.417a1.5 1.5 0 0 0-.618.123 1.6 1.6 0 0 0-.525.366 1.7 1.7 0 0 0-.349.553 1.8 1.8 0 0 0-.116.652V24.91c.012.09.051.172.111.236a.4.4 0 0 0 .223.117h9.834a.36.36 0 0 0 .269-.098c.051-.045.086-.097.086-.255v-2.122c0-.27-.106-.382-.355-.382h-6.005a.77.77 0 0 1-.568-.252.8.8 0 0 1-.172-.277.8.8 0 0 1-.057-.326v-1.02a1.03 1.03 0 0 0-.297-.674.92.92 0 0 0-.656-.27v-.375h6.232a.341.341 0 0 0 .339-.227.4.4 0 0 0 .024-.148v-1.98a.37.37 0 0 0-.097-.278.311.311 0 0 0-.266-.096h-4.482a.77.77 0 0 1-.572-.255.86.86 0 0 1-.225-.608v-.907a1.03 1.03 0 0 0-.283-.7.9.9 0 0 0-.309-.212.9.9 0 0 0-.361-.07v-.376z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint2_linear_2937_4589)",
                        d: "M175.373 10.525h-1.577a1.68 1.68 0 0 0-1.178.5 1.74 1.74 0 0 0-.498 1.195v3a.856.856 0 0 1-.516.795 9.9 9.9 0 0 1-4.015.75.9.9 0 0 1-.508-.18.7.7 0 0 1-.266-.276.7.7 0 0 1-.074-.377V10.9c0-.262-.111-.375-.37-.375h-1.578a1.66 1.66 0 0 0-1.181.496 1.7 1.7 0 0 0-.494 1.2v12.688a.33.33 0 0 0 .211.332.3.3 0 0 0 .137.02h2.905a.36.36 0 0 0 .274-.098.28.28 0 0 0 .096-.255V20.77a.95.95 0 0 0-.229-.637 1.16 1.16 0 0 0-.62-.308v-.375h.473q.368.02.738 0c1.32.027 2.64-.132 3.918-.472h.051a.7.7 0 0 1 .214-.038c.2 0 .395.066.553.188a.75.75 0 0 1 .267.622v5.145a.37.37 0 0 0 .113.252.36.36 0 0 0 .256.1h2.898a.4.4 0 0 0 .149-.02.38.38 0 0 0 .206-.193.3.3 0 0 0 .015-.14V10.9c-.022-.262-.133-.375-.37-.375"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint3_linear_2937_4589)",
                        d: "M189.885 13.384a.4.4 0 0 0 .299-.097.3.3 0 0 0 .079-.108.3.3 0 0 0 .023-.132v-2.145a.35.35 0 0 0-.021-.15.36.36 0 0 0-.222-.208.4.4 0 0 0-.158-.016h-9.204a1.8 1.8 0 0 0-1.259.489 1.7 1.7 0 0 0-.384.553 1.6 1.6 0 0 0-.132.652V24.91a.43.43 0 0 0 .368.353h10.815a.42.42 0 0 0 .289-.098.3.3 0 0 0 .084-.115.3.3 0 0 0 .018-.14v-2.122c0-.27-.116-.382-.391-.382h-6.609a.9.9 0 0 1-.338-.066.88.88 0 0 1-.476-.463.9.9 0 0 1-.062-.326v-1.02a.97.97 0 0 0-.326-.674 1.06 1.06 0 0 0-.722-.27v-.375h6.86a.4.4 0 0 0 .281-.105.36.36 0 0 0 .109-.27v-1.98a.328.328 0 0 0-.101-.278.364.364 0 0 0-.289-.096h-4.936a.9.9 0 0 1-.624-.257.9.9 0 0 1-.19-.279.9.9 0 0 1-.062-.327v-.907c0-.13-.027-.26-.081-.38a1 1 0 0 0-.568-.532 1.1 1.1 0 0 0-.399-.07v-.376z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint4_linear_2937_4589)",
                        d: "M199.176 20.004a.81.81 0 0 1 .756.451l2.27 4.349a.75.75 0 0 0 .705.458h3.087a.34.34 0 0 0 .211-.09.23.23 0 0 0 .06-.158.4.4 0 0 0-.045-.15l-2.753-4.95a.44.44 0 0 1-.062-.36.47.47 0 0 1 .258-.39 4.27 4.27 0 0 0 1.694-1.616 4.2 4.2 0 0 0 .576-2.26c0-4.146-3.723-4.762-5.941-4.762h-4.638a1.68 1.68 0 0 0-1.218.473 1.638 1.638 0 0 0-.499 1.202v12.73a.42.42 0 0 0 .363.33h3.027a.328.328 0 0 0 .257-.098.24.24 0 0 0 .081-.102q.026-.063.017-.13V21.35a1.14 1.14 0 0 0-.264-.669.95.95 0 0 0-.757-.3v-.376zm-3.026-6.376v-.376h3.782c.55-.019 1.087.16 1.514.504a1.93 1.93 0 0 1 .59 1.502c0 1.209-.795 1.922-2.12 1.922h-1.898a.76.76 0 0 1-.605-.262.74.74 0 0 1-.242-.571v-1.758a1 1 0 0 0-.313-.682 1.02 1.02 0 0 0-.701-.28z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint5_linear_2937_4589)",
                        d: "M220.954 16.115c-.117-3.552-2.603-5.59-6.805-5.59-4.204 0-6.705 2.038-6.829 5.59v3.611c.117 3.56 2.546 5.525 6.829 5.525 1.775.095 3.527-.404 4.937-1.407 1.915-1.515 1.915-3.756 1.915-5.916v-1.175zm-3.969 2.785v.724c-.046 1.813-1.077 2.857-2.813 2.857-1.734 0-2.79-1.044-2.836-2.857v-3.451c.046-1.841 1.055-2.856 2.836-2.856s2.767 1.015 2.813 2.856v1.704c0 .254.015.537 0 .986z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_2937_4589",
                        x1: "4.855",
                        x2: "14.091",
                        y1: "25.945",
                        y2: "25.327",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FFC225"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF8D3F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_2937_4589",
                        x1: "14.868",
                        x2: "47.979",
                        y1: "30.352",
                        y2: "4.788",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.13",
                                stopColor: "#FF8C22"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF291C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_2937_4589",
                        x1: "169.413",
                        x2: "169.413",
                        y1: "24.953",
                        y2: "15.782",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.13",
                                stopColor: "#FF8C22"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF291C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_2937_4589",
                        x1: "184.692",
                        x2: "184.692",
                        y1: "24.977",
                        y2: "15.806",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.13",
                                stopColor: "#FF8C22"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF291C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint4_linear_2937_4589",
                        x1: "199.91",
                        x2: "199.91",
                        y1: "24.976",
                        y2: "15.791",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.13",
                                stopColor: "#FF8C22"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF291C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint5_linear_2937_4589",
                        x1: "214.149",
                        x2: "214.149",
                        y1: "24.692",
                        y2: "15.825",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.13",
                                stopColor: "#FF8C22"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF291C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_2937_4589",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h221v40H0z"
                        })
                    })
                ]
            })
        ]
    });
/* harmony default export */ var revenueHeroIcon = (RevenueHeroIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/whyOutsource/icons/cmoCouncilIcon.tsx


const CMOCouncilIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "66",
        height: "40",
        fill: "none",
        viewBox: "0 0 66 40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2935_4550)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E51A2E",
                        d: "M35.124.371v9.08h.83V1.565l4.115 7.892.34-.02 3.656-7.23c.104-.08.46.292.46.32v6.926h1.66V4.315c2.584 3.091 2.788 7.595 1.104 11.19-.24.028-.146-.001-.186-.133-2.04-6.872-12.232-5.166-11.517 2.563.12 1.311.87 2.44 1.657 3.44-6.824-.313-11.635-6.643-10-13.298.912-3.717 4.075-6.954 7.88-7.705zm-.37 13.029-.782-.55c-1.255 1.653-3.817 1.087-4.406-.848-.833-2.738 1.975-5.007 4.296-3.02l.702-.598c-1.422-1.837-4.554-1.347-5.663.607-1.55 2.734.368 6.097 3.595 5.78.747-.074 2.01-.608 2.258-1.371"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E51A2E",
                        d: "M41.096 12.32c2.89-.211 5.085 2.364 4.81 5.154-1.174 1.51-2.984 2.76-4.833 3.353-.823.264-1.436.563-2.199.073-3.377-2.167-2.163-8.258 2.223-8.58"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "m9.82 13.395 2.49 5.687 2.35-5.687h1.935v8.255h-1.474v-5.504l-2.44 5.51-.925-.098-2.258-5.412v5.504H8.023v-8.255zM30.424 29.722V23.76h1.475v8.117l-.139.138h-1.474l-4.194-5.962v5.962h-1.337l-.138-.138V23.76h1.705z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M21.28 13.24c6.305-.583 6.336 9.473-.371 8.57-4.668-.627-4.753-8.097.371-8.57m2.383 6.452c1.45-1.479.838-4.76-1.396-5.013-4.523-.509-4.326 6.278-.102 5.769.505-.06 1.145-.396 1.499-.756zM11.137 23.599c6.394-.808 6.698 8.46.903 8.603-5.584.138-5.895-7.972-.903-8.603m.277 1.377c-3.74.544-2.598 7.1 1.495 5.615 2.898-1.051 2.063-6.134-1.495-5.616"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M18.442 23.76v5.64c0 .041.239.548.291.628.735 1.126 2.49.99 3.015-.272.04-.096.196-.49.196-.539V23.76h1.475v5.732c0 .588-.807 1.759-1.296 2.105-2.091 1.477-5.248.058-5.248-2.563V23.76zM39.995 25.124l-1.126.736c-2.311-2.36-5.373.237-4.435 3.126.65 1.998 3.467 2.508 4.606.646l1.159.878c-.31.757-1.334 1.361-2.123 1.555-3.824.944-6.646-3.136-4.752-6.472 1.047-1.843 3.379-2.5 5.325-1.718.315.126 1.551.893 1.346 1.25zM3.861 13.24c1.212-.118 2.759.314 3.433 1.394l-1.156.96c-1.269-1.677-3.802-1.031-4.423.922-.988 3.107 2.439 5.45 4.607 2.864l1.115.803c.217.394-1.198 1.229-1.504 1.355-6.108 2.506-8.48-7.68-2.072-8.299M7.46 30.469c.158.276-.834 1.024-1.066 1.162C3.395 33.403-.2 30.949.01 27.568.244 23.757 4.896 22.12 7.379 25l-1.168.86c-.705-.586-1.212-.987-2.195-.904-1.984.166-2.89 2.376-2.275 4.097.696 1.955 3.458 2.408 4.58.58z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E51A2E",
                        d: "M37.059.005c2.208-.06 4.52.452 6.353 1.705l-2.713 5.355z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M45.076 23.76v6.787h3.595v1.468H43.74l-.138-.138V23.76zM42.313 23.76v8.117L42.16 32c-.084.027-.172.012-.257.02-.325.027-.92.066-1.157-.143V23.76zM54.02 39.262c.243.026.145-.005.185-.136.224-.744.407-1.503.652-2.24h.302L56 39.353l.682-2.422.378-.054-.917 2.984-.368.038-.696-2.38-.774 2.33-.24.06-.164-.119-.803-2.912.35.154zM28.292 36.888l.657 2.465.745-2.466.396-.015.747 2.483.702-2.467.358-.01-.834 3.022-.307-.006-.84-2.467-.707 2.324-.441.149-.83-2.89c-.058-.22.22-.13.354-.122M46.83 39.26v-2.384h.369v3.027l-.506-.093-1.706-2.384v2.477l-.282-.04-.087-.19c.07-.785-.094-1.717-.005-2.48.042-.356.21-.416.518-.232zM40.102 39.904v-3.027h1.336c.04 0 .55.237.63.29.857.558.857 1.888 0 2.447-.08.052-.59.29-.63.29zm.368-.367c.917.083 1.851-.021 1.851-1.147 0-1.125-.934-1.229-1.85-1.146zM25.888 36.805c2.233-.242 2.356 3.143.246 3.191-2.001.046-2.2-2.979-.246-3.19m-.192.365c-1.036.237-1.083 2.105-.07 2.416 2.118.654 2.274-2.918.07-2.416M58.604 36.806c2.16-.344 2.536 2.989.427 3.186s-2.375-2.876-.427-3.186m-.094.367c-1.124.231-1.123 2.264.077 2.45 2.051.316 2-2.878-.077-2.45M34.938 36.877c.537.018 1.75-.158 1.915.524.125.522-.07.985-.625 1.037l.736 1.465c-.357.316-1.02-1.107-1.12-1.36l-.538-.015v1.376h-.368zm.368 1.284c.334-.02 1.12.13 1.201-.323.141-.785-.686-.58-1.2-.595zM61.113 36.877c.53.016 1.762-.155 1.916.525.124.543-.146 1.031-.717 1.08l.829 1.421c-.89.077-.696-1.567-1.659-1.374v1.375h-.369zm1.453 1.17c.15-.148.172-.573-.016-.72-.23-.179-.774-.042-1.069-.084v.919c.271-.025.893.077 1.084-.114M17.981 36.876c.397.027.834-.048 1.223.022.967.175.95 1.486-.024 1.583l.828 1.422c-.876.086-.736-1.554-1.659-1.375l-.015 1.225-.354.152v-3.027zm1.453 1.17c.18-.178.127-.592-.07-.758l-1.014-.045v.918c.273-.024.891.078 1.084-.113zM48.396 37.244v.917h1.337l.138.139-.139.228h-1.336v1.009h1.567v.367h-1.936v-3.027h1.798l.138.227-.138.14zM17.334 36.877l-.138.367h-1.429v.917h1.475l-.138.367h-1.337v1.009h1.567v.367h-1.797l-.139-.138v-2.751l.139-.138zM39.457 36.877v.367H37.89v.917h1.474v.367H37.89v1.009h1.52l.139.367h-1.936v-3.027zM34.293 36.877v.367h-1.567v.917H34.2v.367h-1.474v1.009h1.52l.139.367h-1.936v-3.027zM14.754 36.877v.367h-1.567v.917h1.474v.367h-1.474v1.009h1.52l.139.367H12.91v-3.027zM8.394 36.877v.367H6.827v.917h1.475v.367H6.827v1.009h1.521l.138.367H6.551v-3.027zM64.063 36.877v1.284c.637-.345 1.105-1.319 1.844-1.283l-1.376 1.408 1.468 1.617c-.887.037-1.245-1.147-1.936-1.558v1.559l-.282-.04v-2.946z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M22.497 38.527v1.376l-.282-.04-.047-2.9c2.177-.704 2.762 1.812.328 1.564zm1.084-1.17-1.084-.114v.918l1.045-.085.149-.335zM10.422 36.876c.597.036 1.287-.164 1.742.33.447 1.126-.408 1.414-1.374 1.321l-.014 1.225-.354.152zm.369 1.284c1.534.279 1.536-1.196 0-.918zM3.694 36.877v1.284h1.66v-1.284h.276v3.027h-.276v-1.376h-1.66v1.376h-.276v-3.027zM52.728 36.877l-.153.352-.861.015v2.66h-.369v-2.66l-.86-.015-.153-.125.137-.227zM2.863 36.877v.366H1.85v2.66l-.369-.137v-2.522l-.921-.001v-.366zM48.766 23.027l.416.09.32.828.137-.828.417-.09v1.468c-.423-.003-.247-.538-.277-.825l-.185.826-.28-.041-.226-.786-.062.673-.26.153zM48.489 23.027v.275h-.37c-.038.036.025.868.001 1.056-.017.134-.07.285-.184.136v-1.192h-.37v-.275zM21.484 38.71h-1.199v.275h1.2z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2935_4550",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h66v40H0z"
                    })
                })
            })
        ]
    });
/* harmony default export */ var cmoCouncilIcon = (CMOCouncilIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/whyOutsource/icons/semrushIcon.tsx


function SemrushIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "237",
        height: "32",
        fill: "none",
        viewBox: "0 0 237 32",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_1380_11212)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    clipPath: "url(#clip1_1380_11212)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#000",
                            d: "M162.68 12.277c0-3.855-2.371-6.662-6.919-6.662H141.07v19.99h4.825v-6.822h5.714l5.595 6.82h5.437v-.433l-5.437-6.506c3.421-.692 5.476-3.184 5.476-6.387zm-7.453 2.472h-9.313V9.767h9.313c1.72 0 2.827.91 2.827 2.491 0 1.62-1.067 2.49-2.827 2.49zm80.392-9.134h-4.529v7.592h-12.159V5.615h-4.883v20.01h4.883v-7.89h12.159v7.89h4.529V5.614zm-107.458 0l-5.379 16.825h-.296l-5.397-16.825h-8.603v20.01h4.606V9.192h.277l5.378 16.431h7.415l5.398-16.431h.276v16.431h4.746V5.615h-8.424.003zM75.608 13.8c-1.701-.176-4.884-.473-6.584-.651-1.68-.178-2.65-.673-2.65-1.78 0-1.067 1.028-1.958 5.18-1.958 3.678 0 7.058.792 10.005 2.216v-4.47c-2.945-1.403-6.21-2.095-10.263-2.095-5.693 0-9.628 2.372-9.628 6.406 0 3.401 2.313 5.26 6.94 5.773 1.68.18 4.527.435 6.525.593 2.174.18 2.808.85 2.808 1.84 0 1.364-1.524 2.194-5.378 2.194-3.916 0-7.89-1.286-10.717-3.084v4.606c2.274 1.524 6.19 2.808 10.558 2.808 6.208 0 10.203-2.392 10.203-6.683.039-3.242-2.096-5.2-7-5.713l.001-.002zM85.81 5.615v20.01h18.644v-4.096H90.416v-4.052h13.8v-4.054h-13.8V9.707h14.039V5.615H85.808h.001zM204.063 13.8c-1.701-.176-4.884-.473-6.584-.651-1.681-.178-2.649-.673-2.649-1.78 0-1.067 1.028-1.958 5.18-1.958 3.677 0 7.058.792 10.004 2.216v-4.47c-2.946-1.403-6.208-2.095-10.261-2.095-5.695 0-9.629 2.372-9.629 6.406 0 3.401 2.313 5.26 6.939 5.773 1.681.18 4.529.435 6.525.593 2.175.18 2.808.85 2.808 1.84 0 1.364-1.522 2.194-5.378 2.194-3.914 0-7.888-1.286-10.716-3.084v4.606c2.273 1.524 6.189 2.808 10.557 2.808 6.209 0 10.203-2.392 10.203-6.683.04-3.242-2.096-5.2-6.999-5.713v-.002zm-22.045-8.184v10.242c0 3.875-2.353 6.01-5.892 6.01-3.559 0-5.892-2.096-5.892-6.07V5.615h-4.804v9.727c0 7.256 4.527 10.855 10.775 10.855 5.991 0 10.638-3.44 10.638-10.617V5.615h-4.825z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FF642D",
                            d: "M45.137 15.501c0 .97-.493 1.126-1.72 1.126-1.303 0-1.54-.217-1.68-1.205-.257-2.512-1.957-4.647-4.803-4.885-.91-.077-1.128-.414-1.128-1.541 0-1.047.159-1.541.97-1.541 4.942.019 8.361 3.992 8.361 8.046zm7.198 0C52.335 7.967 47.235 0 35.45 0H12.042c-.476 0-.772.238-.772.673 0 .236.178.454.337.572.849.673 2.115 1.424 3.775 2.255a55.246 55.246 0 004.152 1.858c.533.217.732.455.732.751 0 .416-.297.673-.87.673H.812c-.555 0-.812.356-.812.711 0 .296.099.554.356.81 1.502 1.583 3.914 3.481 7.416 5.676 3.196 1.985 6.496 3.8 9.884 5.436.514.238.672.515.672.81-.019.337-.276.614-.87.614H8.936c-.474 0-.75.257-.75.653 0 .217.178.493.415.712 1.936 1.76 5.042 3.678 9.174 5.436 5.517 2.353 11.11 3.757 17.399 3.757 11.922 0 17.16-8.917 17.16-15.896zm-15.56 11.131c-6.09 0-11.19-4.963-11.19-11.15 0-6.091 5.081-10.994 11.19-10.994 6.248 0 11.15 4.883 11.15 10.994-.019 6.188-4.903 11.15-11.15 11.15z"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_1380_11212",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H236.227V31.397H0z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip1_1380_11212",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H236.227V31.397H0z"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var semrushIcon = (SemrushIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/whyOutsource/index.tsx








const whyOutsource_list = [
    {
        description: "According to RevenueHero's 2024 research, 63.5% of inbound sales inquiries never receive any response at all, letting real opportunities go cold before they're ever worked.",
        mainLogo: /*#__PURE__*/ (0,jsx_runtime.jsx)(revenueHeroIcon, {})
    },
    {
        description: "According to HubSpot, generating high-quality leads remains marketers' single biggest challenge, cited by 61% of respondents. We apply manual verification checks before any lead reaches your team, so what you receive has already been screened.",
        mainLogo: /*#__PURE__*/ (0,jsx_runtime.jsx)(hubSpotIcon, {})
    },
    {
        description: "According to the CMO Council, 64% of B2B marketers say their lead generation and engagement strategy is underperforming.",
        mainLogo: /*#__PURE__*/ (0,jsx_runtime.jsx)(cmoCouncilIcon, {})
    },
    {
        description: "According to Semrush, businesses using AI-assisted content marketing report a 68% increase in content marketing ROI. Our own programs lean on content-rich, SEO-optimized pages built to attract and nurture prospects at scale.",
        mainLogo: /*#__PURE__*/ (0,jsx_runtime.jsx)(semrushIcon, {})
    }, 
];
function WhyOutsource() {
    const mainSectionDevRef = (0,react.useRef)(null);
    const isInView = (0,use_in_view/* useInView */.Y)(mainSectionDevRef, {
        once: true
    });
    const firstEl = (0,use_animation/* useAnimation */._)();
    (0,react.useEffect)(()=>{
        if (isInView) {
            firstEl.start("visible").catch(()=>{});
        }
    }, [
        isInView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.section */.E.section, {
        ref: mainSectionDevRef,
        className: "flex flex-col lg:flex-row items-center gap-5 lg:mt-60 mt-36 overflow-hidden py-4",
        variants: {
            visible: {
                y: [
                    150,
                    0
                ],
                transition: {
                    duration: 1.5
                }
            }
        },
        animate: firstEl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "3xl:max-w-[600px] lg:max-w-[410px] z-10 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "font-bold 3xl:text-7xl 3xl:leading-[5rem] lg:text-5xl text-3xl lg:leading-[54px] leading-9 text-center lg:text-left",
                    children: "The Science of Lead Generation"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sm:flex z-10 items-center justify-center w-full ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareSlider, {
                    deferentStyle: true,
                    list: whyOutsource_list,
                    perPage: 2
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/b2bSlides/sharedSlideInfo.tsx





function SharedSlideInfo({ info  }) {
    const { bgColor , description , title , zIndex , img , scaleValue , yValue  } = info;
    const windowSize = (0,useWindowSize/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.li */.E.li, {
        id: title,
        className: `rounded-[20px]  flex 3xl:h-[630px] lg:h-[480px] h-[540px] gap-6  lg:gap-0  3xl:gap-20 lg:pr-5 3xl:pr-0`,
        style: {
            backgroundColor: bgColor,
            zIndex: zIndex,
            scale: windowSize.width > 1024 ? scaleValue : 1,
            y: windowSize.width > 1024 ? yValue : 0
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: ` pt-14 lg:pt-16 3xl:pt-20 lg:pl-20 px-6 pb-9  max-w-[730px] 3xl:max-w-[1030px] `,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "font-bold 3xl:text-7xl 3xl:leading-[5.5rem] lg:text-5xl text-3xl lg:leading-[3.7rem] leading-9 text-[#37367D]",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "3xl:text-2xl 3xl:leading-10 lg:text-lg lg:leading-8 mt-5 lg:mt-5 font-light",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `w-[281px]  h-[253px] 3xl:w-[740px] 3xl:min-w-[740px] md:w-[580px] md:min-w-[580px]  3xl:h-[630px] md:h-[480px]  relative  mx-auto lg:mx-0 lg:mt-0  3xl:mt-0 hidden lg:block `,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "fill",
                    alt: "Image",
                    objectFit: "cover",
                    src: img
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-scroll.mjs + 11 modules
var use_scroll = __webpack_require__(79645);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-transform.mjs + 4 modules
var use_transform = __webpack_require__(60056);
// EXTERNAL MODULE: ./src/components/severalbrands/homePage/thirdSection/b2bSlides/style.module.scss
var b2bSlides_style_module = __webpack_require__(77420);
var b2bSlides_style_module_default = /*#__PURE__*/__webpack_require__.n(b2bSlides_style_module);
;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/b2bSlides/index.tsx






const b2bSlides_list = [
    {
        title: "Industry Expertise",
        tabName: "Research",
        slug: "research",
        description: "We tailor lead generation to your industry, whether that's legal, auto warranty, B2B, or B2C, designing campaigns around each sector's unique challenges.",
        img: "/severalbrands/assets/images/homePageConnectImg.jpg",
        bgColor: "#E6D4FF"
    },
    {
        title: "Legal",
        tabName: "Legal",
        slug: "legal",
        description: "Legal leads, especially in personal injury and motor vehicle accident cases, are some of the hardest to convert. People searching for legal help are often stressed, unfamiliar with the process, and wary of anything that feels like a sales pitch. We build content and campaigns that demystify what a legal claim actually involves, so the prospects who reach out are already informed and ready for a real conversation with your team.",
        img: "/severalbrands/assets/images/homePageLegalImg.jpg",
        bgColor: "#D4BBFF"
    },
    {
        title: "Auto Warranty",
        tabName: "Auto Warranty",
        slug: "auto-warranty",
        description: "Reaching the right car owners at the right time is tricky but essential. Through geo-targeted ads and behavior-driven strategies, we connect warranty providers with vehicle owners actively researching coverage, optimizing for quality over quantity in every campaign.",
        img: "/severalbrands/assets/images/homePageB2BImg.jpg",
        bgColor: "#C2A1FF"
    },
    {
        title: "B2B & B2C",
        tabName: "B2B & B2C",
        slug: "b2b-b2c",
        description: "Whether your leads are other businesses or individual consumers, what converts them is different. B2B leads respond best to lead scoring and LinkedIn-based targeting that keeps prospects engaged instead of sitting stagnant in a queue. B2C leads respond more to trust and immediacy, so we lean on review and comparison platforms, SEM, and social ads to move people from interest to purchase. Either way, campaigns are built around how your specific audience actually buys.",
        img: "/severalbrands/assets/images/homePageB2CImg2.jpg",
        bgColor: "#B081FF"
    }, 
];
const scaleFrom = 1;
const translateFrom = 800;
function B2BSlides() {
    const windowSize = (0,useWindowSize/* default */.Z)();
    const { 0: selectedEl , 1: setSelectedEl  } = (0,react.useState)("legal");
    const { scrollY  } = (0,use_scroll/* useScroll */.v)();
    const { 0: limit , 1: setLimit  } = (0,react.useState)(0);
    const scaleValue1 = (0,use_transform/* useTransform */.H)(scrollY, [
        limit,
        limit + 1200
    ], [
        scaleFrom,
        0.97
    ]);
    const scaleValue2 = (0,use_transform/* useTransform */.H)(scrollY, [
        limit + 1200,
        limit + 2400
    ], [
        scaleFrom,
        0.98
    ]);
    const scaleValue3 = (0,use_transform/* useTransform */.H)(scrollY, [
        limit + 2400,
        limit + 3600
    ], [
        scaleFrom,
        0.99
    ]);
    const yValue2 = (0,use_transform/* useTransform */.H)(scrollY, [
        limit,
        limit + 1200
    ], [
        translateFrom,
        windowSize.width > 2024 ? -610 : -460
    ]);
    const yValue3 = (0,use_transform/* useTransform */.H)(scrollY, [
        limit + 1200,
        limit + 2400
    ], [
        translateFrom,
        windowSize.width > 2024 ? -1220 : -920
    ]);
    const yValue4 = (0,use_transform/* useTransform */.H)(scrollY, [
        limit + 2400,
        limit + 3600
    ], [
        translateFrom,
        windowSize.width > 2024 ? -1830 : -1380
    ]);
    const filteredList = windowSize.width < 1024 ? [
        b2bSlides_list.find((el)=>el.slug === selectedEl)
    ] : [
        ...b2bSlides_list
    ];
    const finalList = filteredList.map((el, index)=>{
        if (index === 0) {
            return {
                ...el,
                zIndex: 1,
                scaleValue: scaleValue1,
                yValue: 0
            };
        }
        if (index === 1) {
            return {
                ...el,
                zIndex: 2,
                scaleValue: scaleValue2,
                yValue: yValue2
            };
        }
        if (index === 2) {
            return {
                ...el,
                zIndex: 3,
                scaleValue: scaleValue3,
                yValue: yValue3
            };
        }
        if (index === 3) {
            return {
                ...el,
                zIndex: 4,
                scaleValue: 1,
                yValue: yValue4
            };
        }
    });
    const { 0: hadFixedStyle , 1: setFixedStyle  } = (0,react.useState)(false);
    const { 0: afterStyle , 1: setAfterStyle  } = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const limit = document.getElementById("mainScrollDivHomePage").getBoundingClientRect().top + window.scrollY + 48;
        setLimit(limit);
        const handleScroll = ()=>{
            if (window.scrollY < limit + 3800 && window.scrollY > limit) {
                setFixedStyle(true);
            } else {
                setFixedStyle(false);
            }
            if (window.scrollY > 7000) {
                setAfterStyle(true);
            } else {
                setAfterStyle(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "mainScrollDivHomePage",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: `${hadFixedStyle && windowSize.width > 1024 ? (b2bSlides_style_module_default()).fixed : ""} ${(b2bSlides_style_module_default()).bgStyleBefore}    ${afterStyle && windowSize.width > 1024 ? (b2bSlides_style_module_default()).bgStyleAfter : ""}`,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `${hadFixedStyle && windowSize.width > 1024 ? "max-w-7xl 3xl:max-w-[120rem] mx-auto block px-4vw lg:px-4  " : ""} `,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold text-3xl leading-9 text-[#37367D] lg:hidden",
                        children: "Industry Expertise"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-5 font-light lg:hidden mb-14",
                        children: "We tailor lead generation to your industry, whether that's legal, auto warranty, B2B, or B2C, designing campaigns around each sector's unique challenges."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center gap-4 sm:gap-10 lg:hidden",
                        children: b2bSlides_list.filter((slide)=>slide.slug !== "research").map((el)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.button */.E.button, {
                                whileHover: {
                                    scale: [
                                        1,
                                        1.2,
                                        1
                                    ],
                                    transition: {
                                        duration: 0.8,
                                        repeat: Infinity,
                                        delay: 0.3
                                    }
                                },
                                className: `block text-[#6340A4] lg:text-lg lg:px-7 sm:px-4 px-2 lg:py-2 py-1 cursor-pointer  ${el.slug === selectedEl ? "border border-[#6340A4] rounded-3xl" : ""}`,
                                onClick: ()=>{
                                    setSelectedEl(el.slug);
                                },
                                children: el.tabName
                            }, el.slug))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "mt-7 lg:mt-0 ",
                        children: finalList?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SharedSlideInfo, {
                                info: el
                            }, index))
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/severalbrands/homePage/thirdSection/index.tsx







function ThirdSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (thirdSection_style_module_default()).bgStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "lg:py-36 py-20",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WeAreGoodWithNumbers, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatClientsSay, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyOutsource, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(B2BSlides, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-[3800px] hidden lg:block "
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components/severalbrands/homePage/forthSection/index.tsx
var forthSection = __webpack_require__(63644);
// EXTERNAL MODULE: ./src/components/severalbrands/metaTags/index.tsx
var metaTags = __webpack_require__(66405);
// EXTERNAL MODULE: ./src/components/severalbrands/utils/index.ts
var utils = __webpack_require__(54531);
// EXTERNAL MODULE: ./src/components/severalbrands/logoSlider/index.tsx
var logoSlider = __webpack_require__(93549);
;// CONCATENATED MODULE: ./pages/severalbrands/index.tsx




// import SecondSection from "@components/severalbrands/homePage/secondSection";






var __N_SSG = true;
function SeveralBrandsHome({ domain  }) {
    const finalLogos = (0,utils/* getFinalLogosForLogoSLider */.fH)(domain.config?.sliderLogos, null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(severalBrandsWrapper/* default */.Z, {
        domainInfo: domain,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(metaTags/* default */.Z, {
                title: domain?.title ?? "Several Brands LLC",
                description: (0,utils/* getDescriptionForHomePage */.fx)(domain),
                keyWords: (0,utils/* getKeyWordsForMetaTags */.U8)(domain)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstSection, {}),
            finalLogos?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(logoSlider/* default */.Z, {
                logos: finalLogos,
                animationDuration: 40,
                showButton: true,
                mainTitle: "Trusted by Hundreds of Companies to Scale Customer Acquisition",
                buttonText: "See Why Businesses Choose Us"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThirdSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(forthSection/* default */.Z, {})
        ]
    });
}


/***/ }),

/***/ 26784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextImageSharedComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32233);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76265);
/* harmony import */ var _components_severalbrands_sharedButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81467);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91173);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);


// import { Player } from "@lottiefiles/react-lottie-player";
// import dynamic from "next/dynamic";
// const Player = dynamic(
//     () => import("@lottiefiles/react-lottie-player").then((mod) => mod.Player),
//     {
//         ssr: false,
//     },
// );




function TextImageSharedComponent({ info  }) {
    const mainSectionDevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const isInView = (0,framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .useInView */ .Y)(mainSectionDevRef, {
        once: true
    });
    const windowSize = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const mainEl = (0,framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .useAnimation */ ._)();
    const firstEl = (0,framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .useAnimation */ ._)();
    const secondEl = (0,framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .useAnimation */ ._)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isInView) {
            mainEl.start("visible").catch(()=>{});
            firstEl.start("visible").catch(()=>{});
            secondEl.start("visible").catch(()=>{});
        }
    }, [
        isInView
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_7__/* .motion.section */ .E.section, {
        ref: mainSectionDevRef,
        variants: {
            visible: info.showAnimation ? {
                y: [
                    150,
                    0
                ],
                opacity: [
                    0,
                    1
                ]
            } : {}
        },
        animate: mainEl,
        transition: {
            duration: 1.5
        },
        className: `flex flex-col lg:flex-row items-center ${info.imgToLeft ? "justify-end" : ""} gap-8 lg:gap-[80px] 3xl:gap-[200px]  `,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_7__/* .motion.div */ .E.div, {
                variants: {
                    visible: windowSize.width < 1024 ? {
                        y: [
                            150,
                            0
                        ],
                        opacity: [
                            0,
                            1
                        ]
                    } : {
                    }
                },
                transition: {
                    duration: 1.5
                },
                animate: firstEl,
                className: `max-w-[700px]  3xl:max-w-[1000px]  mx-auto lg:mx-0  ${info.mainDivTextMarginTop ? info.mainDivTextMarginTop : ""}  ${info.imgToLeft ? "order-2 " : "order-2 lg:order-1"}`,
                children: [
                    info.mainTitle && (info.mainH1Element ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: info.mainTitleClassName ? info.mainTitleClassName : "font-bold lg:text-6xl text-3xl lg:leading-[79px] 3xl:text-[5.5rem] 3xl:leading-[6.5rem] text-[#351C4F] ",
                        children: info.mainTitle
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: info.mainTitleClassName ? info.mainTitleClassName : "font-bold lg:text-6xl text-3xl lg:leading-[79px] 3xl:text-[5.5rem] 3xl:leading-[6.5rem] text-[#351C4F] ",
                        children: info.mainTitle
                    })),
                    info.secondTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: " font-semibold text-2xl lg:text-4xl 3xl:text-5xl 3xl lg:leading-[45px] 3xl:leading-[3.5rem] mt-2 3xl:mt-4 text-[#351C4F]",
                        children: info.secondTitle
                    }),
                    info.paragraphs && info.paragraphs?.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: info.paragraphs?.map((pInfo, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: info.paragraphsClassName ? info.paragraphsClassName : "lg:mt-8 mt-6 font-light lg:text-lg 3xl:text-[26px] 3xl:leading-[2.5rem] text-base lg:leading-8 ",
                                children: pInfo
                            }, index))
                    }),
                    info.showButton && (info.buttonTitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "lg:mt-12 mt-7 w-fit mx-auto lg:mx-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_sharedButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            regularButton: true,
                            scrollButton: true,
                            children: info.buttonTitle
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "lg:mt-12 mt-7 w-fit mx-auto lg:mx-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_sharedButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            href: "/key-considerations",
                            children: info.guideButtonTitle || "Claim Your Free Guide"
                        })
                    }))
                ]
            }),
            info.img && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_7__/* .motion.div */ .E.div, {
                variants: {
                    visible: windowSize.width < 1024 ? {
                        y: [
                            150,
                            0
                        ],
                        opacity: [
                            0,
                            1
                        ],
                        transition: {
                            duration: 1.5
                        }
                    } : {}
                },
                animate: secondEl,
                className: `${info.imgClassName ? info.imgClassName : ""}  w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative mx-auto lg:mx-0  ${info.imgToLeft ? "order-1" : "order-1 lg:order-2"}`,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    src: info.img,
                    alt: "img",
                    layout: "fill",
                    objectFit: "contain"
                })
            })
        ]
    });
}


/***/ }),

/***/ 63644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ partnerWitUSData; },
/* harmony export */   "Z": function() { return /* binding */ ForthSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_homePage_firstSection_textImageSharedComponent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26784);
/* harmony import */ var _components_severalbrands_whyPartnerWithUs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64080);



const simplifyingComplexDecisions = {
    img: "/severalbrands/assets/images/wantLearnMore.webp",
    mainTitle: "Want to Learn More?",
    mainTitleClassName: "font-bold lg:text-[50px] text-[30px] lg:leading-10 text-[#351C4F] text-center lg:text-left",
    paragraphsClassName: "lg:mt-5  lg:text-[30px]  text-xl lg:leading-10 text-center lg:text-left font-light",
    paragraphs: [
        "Get our free guide, 10 Key Considerations Before Partnering With a Lead Generation Company.", 
    ],
    imgToLeft: true,
    showButton: true,
    showAnimation: true,
    guideButtonTitle: "Download for Free Now"
};
const partnerWitUSData = {
    title: "Why Partner With Us?",
    paragraphs: [
        {
            text: `At Several Brands, the businesses we work with are more than
                clients. They are key collaborators and partners. We only
                succeed if you succeed. When you partner with us, you can expect
                a comprehensive, end-to-end marketing solution that delivers
                results. From lead generation to performance marketing to
                analytics and reporting, we have the expertise to help your
                business succeed.`,
            className: "default"
        },
        {
            text: `Contact us today to learn more about how we can help you achieve
                your marketing goals.`,
            className: "mt-6  3xl:max-w-[1040px] 3xl:text-xl max-w-[740px]  font-light"
        }, 
    ],
    buttonText: "Partner With Us"
};
const partnerWitUSDataHomePage = {
    title: "Ready to Scale with Performance-Based Leads?",
    titleClassName: "max-w-[1040px] !leading-[normal]",
    paragraphs: [
        {
            text: `We tailor high-intent lead campaigns to your business development goals, using performance-based pricing rather than a flat rate. Ready to see what that looks like for your business?`,
            className: "default"
        }, 
    ],
    buttonText: "Get Your Free Consultation"
};
function ForthSection() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "lg:mb-52 mb-36 mt-16 lg:mt-0 ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "lg:mb-20 lg:mt-28 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_homePage_firstSection_textImageSharedComponent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    info: simplifyingComplexDecisions
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-32 lg:mt-10 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_whyPartnerWithUs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    partnerWitUSData: partnerWitUSDataHomePage
                })
            })
        ]
    });
}


/***/ }),

/***/ 93549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LogoSlider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32233);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76265);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71391);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_severalbrands_sharedButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81467);






function LogoSlider({ logos , animationDuration , showButton , mainTitle , buttonText  }) {
    const mainSectionDevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: removeAnimationStyle , 1: setRemoveAnimationStyle  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const isInView = (0,framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .useInView */ .Y)(mainSectionDevRef, {
        once: true
    });
    const firstEl = (0,framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .useAnimation */ ._)();
    const finalLogos = logos;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const startAnimation = window.innerWidth < 767 ? finalLogos.length > 2 : finalLogos.length > 6;
        if (startAnimation) {
            setRemoveAnimationStyle(false);
            const mainScrolled = document.getElementById("mainSectionDevRef");
            if (mainScrolled) {
                mainScrolled.setAttribute("data-animated", "true");
            }
            const innerScrolled = document.getElementById("innerSectionDevRef");
            if (innerScrolled) {
                const innerScrolledContent = Array.from(innerScrolled.children);
                innerScrolledContent.forEach((item)=>{
                    const duplicatedItem = item.cloneNode(true);
                    innerScrolled.appendChild(duplicatedItem);
                });
            }
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isInView) {
            firstEl.start("visible").catch(()=>{});
        }
    }, [
        isInView
    ]);
    const outerSectionStyle = {
        "--animationDuration": `${animationDuration ? animationDuration : 40}s`
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.section */ .E.section, {
        ref: mainSectionDevRef,
        id: "mainSectionDevRef",
        className: ` 3xl:mt-36 lg:mt-32 mt-24    relative  mx-auto ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().scrolled)}`,
        variants: {
            visible: {
                y: [
                    150,
                    0
                ],
                opacity: [
                    0,
                    1
                ],
                transition: {
                    duration: 1.5
                }
            }
        },
        animate: firstEl,
        style: outerSectionStyle,
        children: [
            !removeAnimationStyle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "hidden lg:block absolute inset-0 z-20 before:absolute before:left-0 before:top-0 before:w-1/4 before:h-full before:bg-gradient-to-r before:from-white before:to-transparent before:filter before:blur-3 after:absolute after:right-0 after:top-0 after:w-1/4 after:h-full after:bg-gradient-to-l after:from-white after:to-transparent after:filter after:blur-3"
            }) //the shadow on both sides on the slider
            ,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "relative z-30 font-bold 3xl:text-6xl lg:text-4xl text-2xl lg:leading-10 text-center ",
                children: mainTitle || "We Collaborate With 600+ Companies in Different Sectors"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "innerSectionDevRef",
                className: `mt-7 lg:mt-12  3xl:mt-20  3xl:h-[60px] lg:h-[45px] h-[29px] ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().scrolled__inner)} ${removeAnimationStyle ? "justify-center" : ""}`,
                children: finalLogos?.map((logo, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `w-[120px]  lg:w-[172px] 3xl:w-[250px] relative `,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative mx-auto w-[80%] h-[100%] block",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: logo.path,
                                alt: logo.slug,
                                layout: "fill",
                                objectFit: "contain",
                                loading: "eager"
                            })
                        })
                    }, index))
            }),
            showButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "z-30 relative 3xl:mt-20 mt-12 text-center w-fit mx-auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_sharedButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    href: "/partner-with-us",
                    children: buttonText || "Partner With Us"
                })
            })
        ]
    });
}


/***/ }),

/***/ 81467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SharedButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57772);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function SharedButton({ children , href , pdf , regularButton =false , onCLick , scrollButton =false  }) {
    const scrollToTop = ()=>{
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    const buttonClassName = `  text-white  py-3 sm:px-16 px-7 sm:text-lg 3xl:text-2xl font-bold rounded-lg cursor-pointer block w-fit ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_1___default().btnStyle)}`;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: regularButton ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            onClick: scrollButton ? scrollToTop : onCLick,
            className: buttonClassName,
            children: children
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            target: pdf ? "_blank" : "_self",
            rel: "noreferrer",
            className: buttonClassName,
            children: children
        })
    });
}


/***/ }),

/***/ 54531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ getUrl; },
/* harmony export */   "L0": function() { return /* binding */ getFormattedDate; },
/* harmony export */   "U8": function() { return /* binding */ getKeyWordsForMetaTags; },
/* harmony export */   "Z5": function() { return /* binding */ getMetaTitleDescriptionForPage; },
/* harmony export */   "_7": function() { return /* binding */ getDescriptionForPostByID; },
/* harmony export */   "_H": function() { return /* binding */ getMainTitlesNavigationFromBody; },
/* harmony export */   "fH": function() { return /* binding */ getFinalLogosForLogoSLider; },
/* harmony export */   "fx": function() { return /* binding */ getDescriptionForHomePage; },
/* harmony export */   "nn": function() { return /* binding */ addStyleClassToIframe; },
/* harmony export */   "qp": function() { return /* binding */ getKeyWordsForPostByID; },
/* harmony export */   "yV": function() { return /* binding */ addStyleClassToTable; }
/* harmony export */ });
/* unused harmony export extractExcerptFromBody */
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75094);

const getUrl = (pathname = "")=>{
    return `${window.location.origin}${pathname}`;
};
const getMainTitlesNavigationFromBody = (html)=>{
    const regex = /<[^>]+ id="([^"]+)"[^>]*>([\s\S]+?)<\/[^>]+>/g;
    const result = [];
    let match;
    while(match = regex.exec(html)){
        const [, id, content] = match;
        const textNodes = content.match(/>([^<]+)/g);
        if (textNodes) {
            result.push(// eslint-disable-next-line no-unsafe-optional-chaining
            ...textNodes?.map((node)=>({
                    value: node.substring(1).trim(),
                    id
                })));
        } else {
            result.push({
                value: content.trim(),
                id
            });
        }
    }
    return result.filter((i)=>i.value?.length > 1).map((el)=>({
            title: /^\d/.test(el.value) ? el.value.replace(/^\d/, "").slice(1) : el.value,
            link: `#${el.id}`
        }));
};
const addStyleClassToTable = (body)=>{
    if (body) {
        // start tag replace with <div className="table-responsive" > <table
        const firstSectionStartTag = body?.split("<table")[0]; // first section dose not contain <table to replace
        const bodyAfterReplaceStartTag = body?.split("<table").slice(1).map((table)=>{
            return `<div class="table-responsive"> <table ${table}`;
        });
        // final body after replace start tag
        const bodyAfterAddingStartTag = [
            firstSectionStartTag,
            ...bodyAfterReplaceStartTag, 
        ].join(" ");
        // end tag replace with </table> </div>
        const firstSectionEndTag = bodyAfterAddingStartTag.split("</table>")[0];
        const bodyAfterReplaceEndTag = bodyAfterAddingStartTag.split("</table>").slice(1).map((table)=>{
            return `</table></div>${table}`;
        });
        // final body after replace
        const finalBody = [
            firstSectionEndTag,
            ...bodyAfterReplaceEndTag
        ].join(" ");
        return finalBody;
    } else {
        return body;
    }
};
const addStyleClassToIframe = (body)=>{
    if (body) {
        // start tag replace with <div className="iframe-responsive" > <iframe
        const firstSectionStartTag = body?.split("<iframe")[0]; // first section dose not contain <iframe to replace
        const bodyAfterReplaceStartTag = body?.split("<iframe").slice(1).map((iframe)=>{
            return `<div class="iframe-responsive"> <iframe ${iframe}`;
        });
        // final body after replace start tag
        const bodyAfterAddingStartTag = [
            firstSectionStartTag,
            ...bodyAfterReplaceStartTag, 
        ].join(" ");
        // end tag replace with </iframe> </div>
        const firstSectionEndTag = bodyAfterAddingStartTag.split("</iframe>")[0];
        const bodyAfterReplaceEndTag = bodyAfterAddingStartTag.split("</iframe>").slice(1).map((iframe)=>{
            return `</iframe></div>${iframe}`;
        });
        // final body after replace
        const finalBody = [
            firstSectionEndTag,
            ...bodyAfterReplaceEndTag
        ].join(" ");
        return finalBody;
    } else {
        return body;
    }
};
const getFormattedDate = (date)=>{
    const regex = /^[0-9]+$/; //check if the string contain only numeric characters(time stamp)
    return new Date(regex.test(date) ? +date : date).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
};
const extractExcerptFromBody = (body, characters)=>{
    return body.replace(/<[^>]+>/g, "").substring(0, characters).trim();
};
const getDescriptionForPostByID = (post)=>{
    if (post && post?.metatags && post?.metatags?.length) {
        for(let i = 0; i < post?.metatags.length; i++){
            if (post.metatags[i]?.key === "description" && post.metatags[i]?.value) {
                return post?.metatags[i]?.value;
            }
        }
    }
    if (post?.excerpt) {
        return extractExcerptFromBody((0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .replacePlaceholders */ .wT)(post.excerpt, {
            category: post?.category?.label ?? post?.category?.name
        }), 160);
    }
    if (post?.body) {
        return extractExcerptFromBody((0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .replacePlaceholders */ .wT)(post.body, {
            category: post?.category?.label ?? post?.category?.name
        }), 160);
    }
    return "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks.";
};
const getKeyWordsForPostByID = (post, domainInfo)=>{
    if (post && post?.metatags && post?.metatags?.length) {
        for(let i = 0; i < post?.metatags.length; i++){
            if (post?.metatags[i]?.key === "keywords" && post?.metatags[i]?.value) {
                return post?.metatags[i]?.value;
            }
        }
    }
    if (post?.tags) {
        return post?.tags?.map((tag)=>tag?.name).join(",");
    }
    for(let i1 = 0; i1 < (domainInfo?.metatags.length ?? 0); i1++){
        if (domainInfo?.metatags[i1]?.key === "keywords" && domainInfo?.metatags[i1]?.value) {
            return domainInfo?.metatags[i1]?.value;
        }
    }
    return "";
};
const getDescriptionForHomePage = (domain)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        for(let i = 0; i < (domain?.metatags?.length ?? 0); i++){
            if (domain?.metatags[i]?.key === "extra-meta-HomePage-meta-description" && domain?.metatags[i]?.value) {
                return domain?.metatags[i]?.value;
            }
        }
    }
    if (domain?.description) {
        return domain.description.replace(/<[^>]+>/g, "");
    }
    return "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks.";
};
const getKeyWordsForMetaTags = (domain)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        for(let i = 0; i < (domain?.metatags?.length ?? 0); i++){
            if (domain?.metatags[i]?.key === "keywords" && domain?.metatags[i]?.value) {
                return domain?.metatags[i]?.value;
            }
        }
    }
    return "";
};
const getMetaTitleDescriptionForPage = (domain, keyPage)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        return {
            title: domain?.metatags.find((metaTag)=>metaTag.key === `extra-meta-${keyPage}-meta-title`)?.value,
            description: domain?.metatags.find((metaTag)=>metaTag.key === `extra-meta-${keyPage}-meta-description`)?.value
        };
    }
};
const getFinalLogosForLogoSLider = (featuredList, categorySlug)=>{
    const finalLogos = featuredList ? categorySlug ? featuredList[categorySlug] : featuredList["default"] : [];
    return finalLogos;
};


/***/ }),

/***/ 64080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WhyPartnerWithUs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32233);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76265);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12658);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _sharedButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81467);





function WhyPartnerWithUs({ partnerWitUSData  }) {
    const mainSectionDevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const isInView = (0,framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .Y)(mainSectionDevRef, {
        once: true
    });
    const firstEl = (0,framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .useAnimation */ ._)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isInView) {
            firstEl.start("visible").catch(()=>{});
        }
    }, [
        isInView
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .motion.section */ .E.section, {
        ref: mainSectionDevRef,
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().bgStyle),
        variants: {
            visible: {
                y: [
                    150,
                    0
                ],
                opacity: [
                    0,
                    1
                ],
                transition: {
                    duration: 1.5
                }
            }
        },
        animate: firstEl,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: `font-bold 3xl:text-6xl lg:text-5xl text-3xl lg:leading-[54px] leading-9 ${partnerWitUSData.titleClassName ?? ""}`,
                children: partnerWitUSData.title
            }),
            partnerWitUSData.paragraphs.map((p, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: p.className === "default" ? "3xl:mt-6  mt-3 3xl:text-2xl  3xl:leading-10 lg:text-lg  3xl:max-w-[1040px] max-w-[740px]  font-light" : p.className,
                    children: p.text
                }, index)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "lg:mt-9 mt-12 w-fit ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sharedButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    href: "/partner-with-us",
                    children: partnerWitUSData.buttonText
                })
            })
        ]
    });
}


/***/ }),

/***/ 89182:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__X7Hwx","hero-section":"style_hero-section__NrNw5"};

/***/ }),

/***/ 77420:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgStyleBefore":"style_bgStyleBefore__FFZ8x","bgStyleAfter":"style_bgStyleAfter__A03jP","fixed":"style_fixed__vpBOC"};

/***/ }),

/***/ 55727:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sliderMainContainer":"style_sliderMainContainer__23ZKk","sliderMainContainerDeferentStyle":"style_sliderMainContainerDeferentStyle__YUjaF","dotsStyle":"style_dotsStyle__2AE_m","slide":"style_slide__QUFYi"};

/***/ }),

/***/ 7913:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__viLbL"};

/***/ }),

/***/ 96051:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__czwO5"};

/***/ }),

/***/ 71391:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","scrolled":"style_scrolled__fS6VT","scrolled__inner":"style_scrolled__inner__gigDt","scroll":"style_scroll__sLdOC"};

/***/ }),

/***/ 57772:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btnStyle":"style_btnStyle___YUoh"};

/***/ }),

/***/ 12658:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__n_Qd3"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [11943,33646,23567,97842,81711,49774,92888,40179], function() { return __webpack_exec__(89041); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);